class CollectionScroller {
  constructor() {
    this.init();
  }

  init() {
    let mql = window.matchMedia("(max-width: 768px)");
    let multiColumnInner = document.querySelector(".multi-column__inner");

    if (mql.matches && multiColumnInner) {
      multiColumnInner.classList.add("multi-column__inner--scroller");
    }
  }
}

export default CollectionScroller;
